import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { IAttributes } from 'src/app/models/IAttributes';
import { configuration } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ASCService {

  constructor(private http: HttpClient) { }

   //Get consent details
   getConsentDetails(): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/ConsentDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}&&userId=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }

  //Add consent Details
  addConsentDetails(consentInfo: IAttributes): Observable<string> {
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Master/ConsentDetails'}?facilityId=${sessionStorage.getItem("FacilityId")}`, consentInfo, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }
}
